import React from 'react';
import classes from './style.module.scss';
import Icon from '~/app/common/Icon';
import { TrainingDetailExcavator } from '~/training/types';

export interface MachineItemProps {
  excavator: TrainingDetailExcavator;
}

export type MachineItemComponent = React.FC<MachineItemProps>;

const MachineItem: MachineItemComponent = ({ excavator }) => {
  return (
    <li className={classes['machine-item']}>
      <div className={classes['machine-category-image']}>
        {excavator.categoryImage ? (
          <img src={excavator.categoryImage} alt="" />
        ) : (
          <Icon name="build" className={classes['machine-default-icon']} />
        )}
      </div>
      <div className={classes['machine-info']}>
        <div className={classes['machine-name']}>{excavator.name}</div>
        <div className={classes['machine-code']}>{excavator.intern}</div>
      </div>
    </li>
  );
};

export default MachineItem;
